import React from 'react';
import { Clock3, RotateCcw, RefreshCw } from 'lucide-react';
import { Button } from '../ui/button';
import { AdminUserDialog } from './AdminUserDialog';
import { UserManagementActions } from './UserManagementActions';
import { useUserManagement } from './useUserManagement';
import './userManagement.css';

export const UserControlDialog = ({ account, view, viewerId, onClose, onUpdated }) => {
  const management = useUserManagement(account.id, onUpdated);
  const { data, busy, loading, error, notice, reload } = management;
  const timeout = view === 'timeout';
  return <AdminUserDialog account={data || account} title={timeout ? 'Originals timeout' : 'Daily V credits'} icon={timeout ? Clock3 : RotateCcw}
    testid="user-control-dialog" titleTestid="user-control-title" accountTestid="user-control-account" busy={busy} onClose={onClose} className="user-control-dialog">
    {loading && <p className="user-management-loading" role="status" data-testid="user-control-loading">Loading account…</p>}
    {error && <div className="user-management-error" role="alert" data-testid="user-control-error">{error}{!data && <Button variant="outline" data-testid="user-control-retry" onClick={reload}><RefreshCw size={15} />Retry</Button>}</div>}
    {notice && <p className="user-management-success" role="status" data-testid="user-control-success">{notice}</p>}
    {data && <UserManagementActions management={management} viewerId={viewerId} view={view} />}
  </AdminUserDialog>;
};